import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import {deleteKey} from '../../utils/exportMethods';
import ConfirmationModal from '../ui/ConfirmationModal';
import {compare} from '../../utils/compare';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";

const dataSource = createStore({
  key: "positionId",
  loadUrl: `${url}/PositionMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/PositionMicroservice`, ///DeleteOrder

  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportPositionsToExcel = async (apiData) => {
  apiData.forEach((obj) => {
    deleteKey(obj, 'positionId');
    deleteKey(obj, 'subMediaId');
    deleteKey(obj, 'mediaId');
    deleteKey(obj, 'positionCategoryId');
    deleteKey(obj, 'name');
  });

  const headers = [
    { header: 'Position', key: 'positionName', autoFit: true },
    { header: 'Media', key: 'mediaName', autoFit: true },
    { header: 'SubMedia', key: 'subMediaName', autoFit: true },
    { header: 'Top Premium', key: 'topPremiumPosition', autoFit: true },
    { header: 'Premium', key: 'premiumPosition', autoFit: true },
    { header: 'Other', key: 'other', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true }
  ];

  await exportToExcel(headers, apiData, 'positions_extract', 'Positions Extract');
};


class Positions extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
       
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          Medias: [],
          SubMedias: [],
          PositionType: [],
          showPublisherMenu: true,
          showAirportMenu: true,
          showVehicleMenu: true,
          showPositionMenu: true,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          edit_submedia_id: '',
          validation: true,
          nameVal:true,
          mediaVal:true,
          submediaVal:true,
          positionVal:true,
          duplicatedValidation:true,
          oldCheckValue: false,
        };

        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.confDiag = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }
 
      // to refresh our datagrid table and close all modals
      useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }

      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false});
      }
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }

      showDisabledEnabledToast = (value) => {
        if(!this.confDiag.current.state.inEditMode) {
          if(!value) {
            toast.success('Position has been enabled');
          }
          else {
            toast.success('Position has been disabled');
          }
        }
        else {
          if(value) {
            toast.success('Position has been enabled');
          }
          else {
            toast.success('Position has been disabled');
          }
        }
      }

    openModal = () => {   
      this.setState({showModal:true,
        validation:true, nameVal:true, mediaVal:true, submediaVal:true, positionVal:true, duplicatedValidation: true, SubMedias: []});
      }
 
    onCreatePosition =()=>{
    let name =this.refs.Name.value.trim();
    let media =this.refs.media.value;
    let submedia =this.refs.submedia.value;
    let position =this.refs.positiontype.value;
    this.setState({duplicatedValidation: true})

    if (name == ""){
      this.setState({nameVal: false})
    }else{
      this.setState({nameVal: true})
    }
    if (media == ""){
      this.setState({mediaVal: false})
    }else{
      this.setState({mediaVal: true})
    }
    if (submedia == ""){
      this.setState({submediaVal: false})
    }else{
      this.setState({submediaVal: true})
    }
    if (position == ""){
      this.setState({positionVal: false})
    }else{
      this.setState({positionVal: true})
    }

      if (name != "" && media != "" && submedia != "" && position != "") {

        let PositionInfo = {
          MediaId: this.refs.media.value,
          SubMediaId: this.refs.submedia.value,
          Name: this.refs.Name.value.trim(),
          PositionCategoryId: this.refs.positiontype.value,
          IsEnabled: true
        };
        apiClient.post(`${url}/PositionMicroservice`, PositionInfo)
          .then(response => {
            const data = response.data;
            if (data) {
              if (data.statusCode == 400) {
                this.setState({ duplicatedValidation: false })
                return;
              } else {
                toast.success('Position has been created');
                this.doubleCloseModals();
                this.useRefresh();
              }
            }
          });
      } else {
        this.setState({ validation: false })
        return;
      }
    }

  onEditPosition = () => {

    let name = this.refs.EditName.value.trim();
    let media = this.refs.Editmedia.value;
    let submedia = this.refs.Editsubmedia.value;
    let position = this.refs.Editpositiontype.value;

    this.setState({ duplicatedValidation: true })

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (media == "") {
      this.setState({ mediaVal: false })
    } else {
      this.setState({ mediaVal: true })
    }
    if (submedia == "") {
      this.setState({ submediaVal: false })
    } else {
      this.setState({ submediaVal: true })
    }
    if (position == "") {
      this.setState({ positionVal: false })
    } else {
      this.setState({ positionVal: true })
    }

    if (name != "" && media != "" && submedia != "" && position != "") {

      let PositionInfo = {
        positionId: this.state.selectedRowIndex,
        MediaId: this.refs.Editmedia.value,
        SubMediaId: this.refs.Editsubmedia.value,
        Name: this.refs.EditName.value.trim(),
        PositionCategoryId: this.refs.Editpositiontype.value,
        IsEnabled: this.state.oldCheckValue
      };

      apiClient.put(`${url}/PositionMicroservice`, PositionInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              if (this.state.oldCheckValue != this.refs.chk_Is_Enabled.checked) {
                this.confDiag.current.state.status = this.refs.chk_Is_Enabled.checked
                this.confDiag.current.state.inEditMode = true;
                this.confDiag.current.state.key = this.state.selectedRowIndex;
                this.confDiag.current.handleOpenConfirmDialog();
              } else {
                toast.success('Position has been updated');
                this.doubleCloseModals();
                this.useRefresh();
              }
            }
          }
        });
    } else {
      this.setState({ validation: false })
      return;
    }
  }

  openEditModal = (e) => {    
    this.fetchSubMedias(e.row.data.mediaId);     
    this.setState({
      showEditModal: true,
      validation: true,
      nameVal: true,
      mediaVal: true,
      submediaVal: true,
      positionVal: true,
      edit_submedia_id: e.row.data.subMediaId,
      duplicatedValidation: true,
      selectedRowIndex: e.row.data.positionId
    });     

    //displaying disabled medias in edit dropdown through our e.row.data
    const enabledMedias = this.state.Medias.filter(obj => {
      return obj.isEnabled === true;
    });
    this.setState({Medias:enabledMedias });
      if(
        enabledMedias.find(x=>x.mediaId == e.row.data.mediaId) == undefined){
          var l_Medias = enabledMedias;
          l_Medias.push( {
            mediaId:e.row.data.mediaId,
            name :e.row.data.mediaName
          })
          l_Medias.sort(compare);
          this.setState({Medias:l_Medias })
        }
        
     //displaying disabled subMedias in edit dropdown through our e.row.data  
    const enabledSubMedias = this.state.SubMedias.filter(obj => {
      return obj.isEnabled === true;
    });
    this.setState({SubMedias:enabledSubMedias });
      if(
        enabledSubMedias.find(x=>x.subMediaId == e.row.data.subMediaId) == undefined){
          var l_SubMedias = enabledSubMedias;
          l_SubMedias.push( {
            subMediaId:e.row.data.subMediaId,
            name :e.row.data.subMediaName
          })
          l_SubMedias.sort(compare);
          this.setState({SubMedias:l_SubMedias })
        }  
    
    this.refs.EditName.value = e.row.data.positionName.trim(); 
    this.refs.Editpositiontype.value = e.row.data.positionCategoryId; 
    this.refs.Editmedia.value = e.row.data.mediaId; 
    this.refs.Editsubmedia.value = e.row.data.subMediaId;
    this.refs.chk_Is_Enabled.checked = e.row.data.isEnabled;
    this.setState({oldCheckValue: e.row.data.isEnabled});
  }
  
  onExportToExcel = () => {
    apiClient.get(`${url}/PositionMicroservice/Export`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportPositionsToExcel(data);
          toast.success('Positions Excel export file has been generated');
        }
      });
  }

  fetchMedias() {
    let initialMedias = [];
    apiClient.get(`${url}/MediaMicroservice`)
      .then(response => {
        const data = response.data;
        initialMedias = data;
        this.setState({
          Medias: initialMedias,
        })
      })
      .catch((error) => {
        if (error === 'Unauthorized') {
          return;
        }
      });
  }

  fetchSubMedias(MediaId) {
    let initialSubMedias = [];
    apiClient.get(`${url}/SubmediaMicroservice/media/${MediaId}`, { headers: { 'Reference': `BudgetScreen`}})
      .then(response => {
        const data = response.data;
        initialSubMedias = data;
        this.setState({
          SubMedias: initialSubMedias,
        });
      });
  }

  fetchPositionType() {
    let initialPositionType = [];
    apiClient.get(`${url}/PositionCategoryMicroservice`)
      .then(response => {
        const data = response.data;
        initialPositionType = data;
        this.setState({
          PositionType: initialPositionType,
        });
      });
  }

  loadSubMediaByMedia = (event) => {
    if(event.target.value != ""){
      this.fetchSubMedias(event.target.value);
    }else{
      this.setState({
        SubMedias: [],
      });
    }
  };

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      showAirportMenu: decoded.can_manage_airport_names === "true",
      showPublisherMenu: decoded.can_manage_publishers_vendors === "true",
      showVehicleMenu: decoded.can_manage_vehicles === "true",
      showPositionMenu: decoded.can_manage_positions === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true"
    });

    this.fetchMedias();
    this.fetchPositionType();
  }

  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }

  Checkisdisabled = (e) =>{
  return !e.row.data.isEnabled ;
  }

  onDelete = (e) => {
    this.confDiag.current.state.key = e.row.data.positionId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleOpenConfirmDialog();
  }

  render() {

    let l_Medias = this.state.Medias;
    let optionMedias = l_Medias.map((media) =>
        <option value={media.mediaId}>{media.name}</option>
    );

    let l_SubMedias = this.state.SubMedias;
    let optionSubMedias = l_SubMedias.map((submedia) =>
        <option value={submedia.subMediaId}>{submedia.name}</option>
    );

    let l_PositionType = this.state.PositionType;
    let optionPositionType = l_PositionType.map((positiontype) =>
        <option value={positiontype.positionCategoryId}>{positiontype.name}</option>
    );

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "positionName", caption: "Position", width: "20%"},
      { dataField: "mediaName", caption: "Media", width: "20%"},
      { dataField: "subMediaName", caption: "SubMedia", width: "20%"},
      { dataField: "topPremiumPosition", caption: "Top Premium Position", width: "20%"},
      { dataField: "premiumPosition", caption: "Premium Position", width: "20%"},
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];
    
    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>            
           {'Media References > Positions Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header" onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Position</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
        <div className="div-body-submenu">
            <div className={this.state.showPublisherMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('publishersvendors')} >              
              <div class="div-submenu-label">
                    <label>Publishers/Vendors</label>
              </div> 
            </div>
            <div className={this.state.showAirportMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('airports')} >              
              <div class="div-submenu-label">
                    <label>Airports</label>
              </div> 
            </div>
            <div  className={this.state.showVehicleMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('vehicles')} >              
              <div class="div-submenu-label">
                    <label>Vehicles</label>
              </div>               
            </div>
            <div  className={this.state.showPositionMenu ? "div-submenu-link active" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('positions')} >              
              <div class="div-submenu-label">
                <label>Positions</label>
              </div>               
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">
          <CustomDataGrid
              dataSource={dataSource}
              keyExpr="positionId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen} className="md-scroll">
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Position</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.validation && this.state.duplicatedValidation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Position form is not allowed.</p></Row>  } 
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Position already exists, your updates cannot be saved. Please go back to Positions Management list to edit the corresponding form.</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="media">
              <Form.Label className={`${this.state.mediaVal ? "normal-title" : "validation-title"} font-size-12`}>Media  <CircleSign/></Form.Label>   
              <Form.Control 
              placeholder="Media" 
              ref="media" 
              as="select"
              required
              onChange={this.loadSubMediaByMedia} 
              className={`select-placeholder ${!this.state.mediaVal && "validation-control"}`}
              >
              <option value="" hidden>Media</option>
                {optionMedias}
              </Form.Control>
              {!this.state.mediaVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>      
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="submedia">
              <Form.Label className={`${this.state.submediaVal ? "normal-title" : "validation-title"} font-size-12`}>SubMedia  <CircleSign/></Form.Label>   
              <Form.Control  
              placeholder="Submedia" 
              ref="submedia" 
              as="select" 
              className={`select-placeholder ${!this.state.submediaVal && "validation-control"}`}
              required
              >
              <option value="" hidden>SubMedia</option>
                {optionSubMedias}
              </Form.Control>
              {!this.state.submediaVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>  
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="positiontype">
              <Form.Label className={`${this.state.positionVal ? "normal-title" : "validation-title"} font-size-12`}>Position Type  <CircleSign/></Form.Label>   
              <Form.Control  
              placeholder="Position Type" 
              ref="positiontype" 
              as="select" 
              required
              className={`select-placeholder ${!this.state.positionVal && "validation-control"}`}>
              <option value="" hidden>Position Type</option>
                {optionPositionType}
              </Form.Control>
              {!this.state.positionVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>  
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreatePosition}>
            Create Position
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen} className="md-scroll">
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Position</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body> 
        {!this.state.validation && this.state.duplicatedValidation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Position form is not allowed.</p></Row>  }  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Position already exists, your updates cannot be saved. Please go back to Positions Management list to edit the corresponding form.</p></Row>  }
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="EditName" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="edit_media">
              <Form.Label className="font-size-12">Media  <CircleSign/></Form.Label>
              <Form.Control className="select-placeholder" placeholder="Media" ref="Editmedia"
                as="select" required readOnly disabled="true" defaultValue="">
                <option value="" hidden>Media</option>
                {optionMedias}
              </Form.Control>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="edit_submedia">
              <Form.Label className="font-size-12">SubMedia  <CircleSign/></Form.Label>
              <Form.Control className="select-placeholder" placeholder="SubMedia" ref="Editsubmedia"
                as="select" required readOnly disabled="true" defaultValue="">
                <option value="" hidden>SubMedia</option>
                {optionSubMedias}
              </Form.Control>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="positiontype">
              <Form.Label className={`${this.state.positionVal ? "normal-title" : "validation-title"} font-size-12`}>Position Type  <CircleSign/></Form.Label>   
              <Form.Control  placeholder="Position Type" ref="Editpositiontype" as="select" className={`${!this.state.positionVal && "validation-control"}`}>
              <option value="" hidden>Position Type</option>
                {optionPositionType}
              </Form.Control>
              {!this.state.positionVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" ref="chk_Is_Enabled" label="Is Enabled" />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditPosition}>
          Update Position
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} editfunction={this.showDisabledEnabledToast} microserviceName="PositionMicroservice" refreshfunction={this.useRefresh}></ConfirmDialog>
      
      </div>
    );
  }
    onShowFilterRowChanged(e) {
      this.setState({
        showFilterRow: e.value
      });
      this.clearFilter();
    }

    onShowHeaderFilterChanged(e) {
      this.setState({
        showHeaderFilter: e.value
      });
      this.clearFilter();
    }

    onCurrentFilterChanged(e) {
      this.setState({
        currentFilter: e.value
      });
    }

    clearFilter() {
      this.dataGrid.clearFilter();
    }
}

export default Positions;
